import { Component, ElementRef, HostBinding, Inject, Renderer2 } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { AssignedSalesRep } from '../../../../models/entities/assigned-sales-rep';

export interface DemoSchedulerDialogInput
{
    assignedSalesRep: AssignedSalesRep;
}

@Component({
    selector: 'app-demo-scheduler-dialog',
    templateUrl: './demo-scheduler-dialog.component.html',
    styleUrls: ['./demo-scheduler-dialog.component.scss'],
})
export class DemoSchedulerDialogComponent
{
    @HostBinding('class.scheduler-dialog-content') schedulerClassValue = false;

    constructor(
            private _renderer: Renderer2,
            private _el: ElementRef,
            @Inject(MAT_DIALOG_DATA) public data: DemoSchedulerDialogInput,
    ) {
    }

    get showAssignedSalesRep() {
        return this.data.assignedSalesRep.name !== 'Support';
    }

    get firstName() {
        const name = this.data.assignedSalesRep.name.split(' ');
        return name[0];
    }

    scheduleDemo(secondary = false) {
        let dataSrc = this.data.assignedSalesRep.meetingLink;
        if (secondary) {
            dataSrc = this.data.assignedSalesRep.secondaryMeetingLink;
        }

        const containerDiv = this._renderer.createElement('div');
        this._renderer.addClass(containerDiv, 'meetings-iframe-container');
        this._renderer.setAttribute(containerDiv, 'data-src', dataSrc + '?embed=true');
        this._renderer.appendChild(this._el.nativeElement.querySelector('#scheduler'), containerDiv);

        const hsScript = document.createElement('script');
        hsScript.type = 'text/javascript';
        hsScript.src = `https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js`;
        this._renderer.appendChild(this._el.nativeElement, hsScript);

        this.schedulerClassValue = true;

        // wait for iframe to enter DOM, then attach scrolling="no" property
        setTimeout(() => {
            this._renderer.setAttribute(this._el.nativeElement.querySelector('#scheduler iframe'), 'scrolling', 'no');
        }, 500);
    }
}
